var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[_c('v-container',[_c('v-card',{attrs:{"elevation":"10"}},[_c('v-card-title',[_vm._v("Please Select the School")]),_c('v-card-text')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }